import React from "react";
import styled from "styled-components";
import { H2Desk, P1Desk } from "../../styles/styles_text";


interface AvaliadosTypes {
	avaliados: number
}

const NumeroAvaliados: React.FC<AvaliadosTypes> = ({ avaliados }) => {
	return (
		<Frame
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<P1Desk style={{ color: "#9497A4", fontWeight: 400 }}>Número de avaliados</P1Desk>
			<H2Desk style={{ color: "#63677A", fontWeight: 400, fontSize: '2.5rem' }}>{avaliados}</H2Desk>
		</Frame>
	);
};

const Frame = styled.div`
	width: 100%;
`;

export default NumeroAvaliados;
